const DOCUMENT = 'APPLICANT_';

const actions = {
  ADD: DOCUMENT + 'ADD',
  ADD_SKILL_ADD_PAGE: DOCUMENT + 'ADD_SKILL_ADD_PAGE',
  ADD_SKILL_EDIT_PAGE: DOCUMENT + 'ADD_SKILL_EDIT_PAGE',
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_LEVEL: DOCUMENT + 'CHANGE_LEVEL',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_SICK_LEAVE_RADIO: DOCUMENT + 'CHANGE_SICK_LEAVE_RADIO',
  CHANGE_SKILL: DOCUMENT + 'CHANGE_SKILL',
  CHANGE_STATUS: DOCUMENT + 'CHANGE_STATUS',
  CHANGE_TAX_INFORMATION: DOCUMENT + 'CHANGE_TAX_INFORMATION',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  DELETE: DOCUMENT + 'DELETE',
  DELETE_SKILL: DOCUMENT + 'DELETE_SKILL',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  RESET_PASSWORD: DOCUMENT + 'RESET_PASSWORD',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  SEND_REQUEST_SUCCESS: DOCUMENT + 'SEND_REQUEST_SUCCESS',
  SEND_REQUEST_ERROR: DOCUMENT + 'SEND_REQUEST_ERROR',
  TOUCH: DOCUMENT + 'TOUCH',
  MIGRATE_TO_DFW_REQUEST: DOCUMENT + 'MIGRATE_TO_DFW_REQUEST',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  changeStatus: data => ({
    type: actions.CHANGE_STATUS,
    payload: data,
  }),

  edit: data => ({
    type: actions.EDIT,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  delete: data => ({
    type: actions.DELETE,
    payload: data,
  }),

  deleteSuccess: () => ({
    type: actions.DELETE_SUCCESS,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  create: () => ({
    type: actions.CREATE,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  changeSkill: data => ({
    type: actions.CHANGE_SKILL,
    payload: data,
  }),

  changeTaxInformation: data => ({
    type: actions.CHANGE_TAX_INFORMATION,
    payload: data,
  }),

  changeLevel: data => ({
    type: actions.CHANGE_LEVEL,
    payload: data,
  }),

  changeProperties: data => ({
    type: actions.CHANGE_PROPERTIES,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  changeSickLeaveRadioBtn: data => ({
    type: actions.CHANGE_SICK_LEAVE_RADIO,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  deleteSkill: data => ({
    type: actions.DELETE_SKILL,
    payload: data,
  }),

  addSkillOnAddPage: data => ({
    type: actions.ADD_SKILL_ADD_PAGE,
    payload: data,
  }),

  addSkillOnEditPage: data => ({
    type: actions.ADD_SKILL_EDIT_PAGE,
    payload: data,
  }),

  resetPassword: data => ({
    type: actions.RESET_PASSWORD,
    payload: data,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  sendRequestSuccess: data => ({
    type: actions.SEND_REQUEST_SUCCESS,
    payload: data,
  }),

  sendRequestError: data => ({
    type: actions.SEND_REQUEST_ERROR,
    payload: data,
  }),

  migrateRequest: data => ({
    type: actions.MIGRATE_TO_DFW_REQUEST,
    payload: data,
  }),
};

export default actions;
